const Animations = {
    Push : (theme) => {
        return {
            pushAnimation: {
                animation: `$pushAnimation 1500ms infinite`
            },
            '@keyframes pushAnimation': {
                '0%': {
                    backgroundColor: theme.palette.primary.main,
                    boxShadow: `0px 0px 5px 0px ${theme.palette.text.primary}`,
                },
                '50%': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#06537C' : '#3EA4BA',
                    boxShadow: `0px 0px 10px 0px ${theme.palette.text.primary}`,
                },
                '100%': {
                    backgroundColor: theme.palette.primary.main,
                    boxShadow: `0px 0px 5px 0px ${theme.palette.text.primary}`,
                }
            },
        };
    }
};

export default Animations;
